import { trackEvent } from "@/common/functions";

const actions = {
    /** Track a Google Event. */
    trackEvent: function(context, payload) {
        const { ga, eventCategory, eventAction, eventLabel, eventValue, disableABTest } = payload;
        const eventData = {
            eventCategory,
            eventAction,
            eventLabel,
            eventValue
        };

        if (!disableABTest) {
            const expChannel = context.getters.getExperimentChannel;
            const expDate = context.getters.getExperimentDate;

            if (expChannel && expDate) {
                eventData.dimension2 = `v_${expChannel}`;
            }
        }

        trackEvent(ga, eventData);
    }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/ABTest/actions.js